import { queryOptions } from '@tanstack/react-query';
import { Domain } from '@repo/domain';
import { resolveRepository } from '../registry/resolveRepository';
export const addressPredictionKeys = {
    all: ['addressPredictions'],
    get: (filter, scope) => ['addressPredictions', filter, scope],
};
export const addressPredictionOptions = {
    get: (filter, scope) => queryOptions({
        queryKey: addressPredictionKeys.get(filter, scope),
        queryFn: async () => {
            const repo = await resolveRepository(Domain.AddressPrediction);
            return repo.get(filter, scope);
        },
    }),
};
